import { useLocation } from "react-router-dom";

const useIsKiosk = () => {
  const { pathname } = useLocation();
  return pathname.startsWith("/kiosk");
};

export default useIsKiosk;
